import styled from "styled-components";
import {GameNavBarWrapperDefaultBox} from "./game-nav-bar-wrapper.default.box";

export const GameNavBarWrapperMrGreenBox = styled(GameNavBarWrapperDefaultBox)`
    background-color: ${({theme}) => theme.colors.background};
    background: linear-gradient(#063125, #024C31, ${({theme}) => theme.colors.background}, #072720);
`;